import { Typography } from '@mui/material';
import * as React from 'react';


export default function PaperHeading(params: {
    children: React.ReactNode
}) {
    return (
        <Typography variant="h5" component="h5" className="notched-heading" style={{
            "padding": "16px",
            "textAlign": "center",
            // "color": "white",
            "margin": "8px",
            // "float": "left",
            // "width": "calc(100% - 32px)"
        }}>
            {params.children}
        </Typography>
    );
}